import React, { useState, useEffect, useRef } from 'react';
import './exception.css';
import { DrugExceptionsClient } from '../../../client/drug-exceptions-client';
import {
    DocumentType,
    Gender,
    RelationshipType
} from '../../../model/Reformulary';
import { TextField, RadioGroup, Radio, FormControlLabel, withStyles, createTheme, ThemeProvider, FormLabel as p, Checkbox, Select, MenuItem, FormControl, InputLabel, makeStyles, Theme, createStyles } from '@mui/material';
import { red } from '@mui/material/colors';
import { useNavigate } from "react-router-dom";
interface HandleError {
    handleError: Function;
}

export default function AdminException(props: HandleError) {
    const userId = sessionStorage.getItem('userId') || '';
    const adminId = JSON.parse(userId);
    const history = useNavigate();
    const userIdentityObject = sessionStorage.getItem('userIdentityObject') || '';
    const ajaxId = JSON.parse(userIdentityObject);
    const drugExceptionsClient = new DrugExceptionsClient();

    const [stepOneVisible, updateStepOneVisible] = useState(true);
    const [stepTwoVisible, updateStepTwoVisible] = useState(false);

    const [memberFirstName, updateMemberFirstName] = useState('');
    const [memberLastName, updateMemberLastName] = useState('');
    const [policyNumber, updatePolicyNumber] = useState('');
    const [certificateNumber, updateCertificateNumber] = useState('');
    const [organizationName, updateOrganizationName] = useState('');
    const [relationshipType, updateRelationshipType] = useState('');

    const [firstName, updateFirstName] = useState('');
    const [lastName, updateLastName] = useState('');
    const [gender, updateGender] = useState('');
    const [dateOfBirthMonth, updateDateOfBirthMonth] = useState('');
    const [dateOfBirthDay, updateDateOfBirthDay] = useState('');
    const [dateOfBirthYear, updateDateOfBirthYear] = useState('');
    const [consented, updateConsented] = useState(false);

    const [images, updateImages] = useState();
    const [pdf, updatePdf] = useState();
    const [docType, updateDoctype] = useState();

    const [submitting, updateSubmitting] = useState(false);

    const root = useRef<HTMLDivElement>(null);

    const theme = createTheme({
        palette: {
            primary: {
                main: '#ff4e00'
            },
            error: red
        },
    });

    function addImages(src: string){
        let newImages;
        if (images !== undefined) {
            newImages = [...images];
        };
        updateImages([...newImages || [], src]);
    }

    async function addToException(data: any) {
            const inputSources = Array.from(document.querySelectorAll('.exception  input'));
            const formData = new FormData();

            inputSources.forEach((source: any, index: number) =>{
                if (source.files[0] !== undefined) {
                    formData.append('image'+index, source.files[0]);
                };

            });

            if (data && adminId) {
                try {

                    const token = adminId.authToken;
                    const response = await drugExceptionsClient.api.post(
                        `/drugexceptions/${data.id}/uploaddocuments`,

                        formData
                        ,
                        {
                            headers:{
                                Authorization: `Bearer ${token}`
                            }
                        }
                    );
                    if (response) {

                        history('/dashboard');
                        props.handleError({
                            error: false,
                            ajax: {
                                request: {
                                    responseText: ['Exception created successfully']
                                }
                            }
                        });
                    }
                } catch (error) {
                    props.handleError({
                        error: true,
                        ajax: error
                    });
                }
            }

    }

    async function createDrugException() {
        updateSubmitting(true);
        let id = ajaxId.id;
        const token = adminId.authToken;

        try {
            const response = await drugExceptionsClient.api.post(
                '/claimants/claimantbyadmin',
                {
                    memberFirstName,
                    memberLastName,
                    policyNumber,
                    certificateNumber,
                    firstName,
                    lastName,
                    dateOfBirth: new Date(Number(dateOfBirthYear), Number(dateOfBirthMonth), Number(dateOfBirthDay)),
                    gender,
                    relationshipType
                },
                {
                    headers:{
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            id = response.data.id;
        } catch(error) {
            props.handleError(error);

            updateSubmitting(false);
            updateImages(undefined);
            return;
        }

        let addedBlob;
        try {
            const response = await drugExceptionsClient.api.post(
                '/drugexceptions',
                {
                    claimantId: id,
                    documentType: docType
                },
                {
                    headers:{
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (response) {
                addedBlob = addToException(response.data);
            }
        } catch(error) {
            props.handleError(error);
        }

    }

    useEffect(()=>{
        if (root.current) {
            const inputSources = Array.from(root.current.querySelectorAll('.exception input'));
            const previewSpots = Array.from(root.current.querySelectorAll<HTMLImageElement>('.exception .image-preview'));
            const previewName = Array.from(root.current.querySelectorAll<HTMLElement>('.exception p'));
            previewSpots.forEach((spot, index) => {
                const fileReader = new FileReader();
                const inputSource: any = inputSources[index];
                const file = inputSource !== undefined ? inputSource.files[0] : false;
                const element = previewName[index];
                element['innerText'] =  inputSource.files[0] ? inputSource.files[0].name : '';

                if (file) {
                    fileReader.addEventListener('load', ()=>{
                        if (typeof fileReader.result === 'string') {
                            spot.setAttribute('src', fileReader.result || '');
                        }
                    });
                    fileReader.readAsDataURL(file);
                }

            });
        }
    });

    function stepTwoAvailable() {
        return memberFirstName !== ''
            && memberLastName !== ''
            && policyNumber !== ''
            && certificateNumber !== ''
            && organizationName !== ''
            && relationshipType !== ''
            && firstName !== ''
            && lastName !== ''
            && gender !== ''
            && dateOfBirthYear !== ''
            && Number(dateOfBirthYear) >= 1900 && Number(dateOfBirthYear) <= 3000
            && dateOfBirthDay !== ''
            && Number(dateOfBirthDay) >= 1 && Number(dateOfBirthDay) <= 31
            && dateOfBirthMonth !== ''
            && consented !== false;
    }

    const handleMemberFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateMemberFirstName((event.target as HTMLInputElement).value);
    };

    const handleMemberLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateMemberLastName((event.target as HTMLInputElement).value);
    };

    const handlePolicyNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updatePolicyNumber((event.target as HTMLInputElement).value);
    };

    const handleCertificateNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateCertificateNumber((event.target as HTMLInputElement).value.toUpperCase());
    };

    const handleOrganizationNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateOrganizationName((event.target as HTMLInputElement).value);
    };

    const handleRelationshipTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        updateRelationshipType(value);

        if (value === RelationshipType[RelationshipType.MEMBER]) {
            updateFirstName(memberFirstName);
            updateLastName(memberLastName);
        } else if (firstName === memberFirstName && lastName === memberLastName) {
            updateFirstName('');
            updateLastName('');
        }
    };

    const handleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateFirstName((event.target as HTMLInputElement).value);
    };

    const handleLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateLastName((event.target as HTMLInputElement).value);
    };

    const handleGenderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateGender((event.target as HTMLInputElement).value);
    };

    const handleMonthChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        updateDateOfBirthMonth(event.target.value as string);
    };

    const handleDayChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        updateDateOfBirthDay(event.target.value as string);
    };

    const handleYearChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        updateDateOfBirthYear(event.target.value as string);
    };

    const handleConsentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateConsented((event.target as HTMLInputElement).checked);
    };
    
    const isAlpaNumeric = function(value: string){
        const regex = new RegExp(/^[a-zA-Z0-9]*$/);
        return regex.test(value);
    };

    const handleCertificateNumberKeyDown = function(e: React.KeyboardEvent<HTMLInputElement>){
        if(!isAlpaNumeric(e.key)) {
            e.preventDefault();
        }         
    };

    function imagesView() {

        return <div className="add-images-container">
            <h1>Submit Your Request</h1>

            <div className="exception">
                <div> 
                    <label htmlFor="page-one" className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">Page One</label>
                    <input id="page-one" type="file" accept=".jpg, .jpeg, .JPG, .JPEG; capture=camera" onChange={e=>addImages(e.target.value)} />
                </div>
                <p></p>
                <img className="image-preview" />
            </div>
            <div className="exception">
                <div>
                    <label htmlFor="page-two" className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">Page Two</label>
                    <input id="page-two" type="file" accept=".jpg, .jpeg, .JPG, .JPEG; capture=camera" onChange={e=>addImages(e.target.value)} />
                </div>
                <p></p>
                <img className="image-preview" />
            </div>
            <div className="exception">
                <div>
                    <label htmlFor="page-three" className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">Page Three</label>
                    <input id="page-three" type="file" accept=".jpg, .jpeg, .JPG, .JPEG; capture=camera" onChange={e=>addImages(e.target.value)} />
                </div>
                <p></p>
                <img className="image-preview" />
            </div>
            <div className="exception">
                <div>
                    <label htmlFor="page-four" className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">Page Four</label>
                    <input id="page-four" type="file" accept=".jpg, .jpeg, .JPG, .JPEG; capture=camera" onChange={e=>addImages(e.target.value)} />
                </div>
                <p></p>
                <img className="image-preview" />
            </div>
        </div>;

    }

    function PDFView() {
        return <div className="add-pdf-container">
            <h1>Submit Your Request</h1>
            <div className="exception">
                <div>
                    <label htmlFor="pdf" className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped">Choose PDF</label>
                    <input id="pdf" type="file"  accept="application/pdf" onChange={e=>updatePdf(e.target.value)} />
                </div>
                <p></p>
                <svg version="1.1" id="Capa_1"  x="50px" y="50px" viewBox="50 0 -50 0" className="image-preview">
                    <g>
                        <path d="M142.024,310.194c0-8.007-5.556-12.782-15.359-12.782c-4.003,0-6.714,0.395-8.132,0.773v25.69
                            c1.679,0.378,3.743,0.504,6.588,0.504C135.57,324.379,142.024,319.1,142.024,310.194z"/>
                        <path d="M202.709,297.681c-4.39,0-7.227,0.379-8.905,0.772v56.896c1.679,0.394,4.39,0.394,6.841,0.394
                            c17.809,0.126,29.424-9.677,29.424-30.449C230.195,307.231,219.611,297.681,202.709,297.681z"/>
                        <path d="M315.458,0H121.811c-28.29,0-51.315,23.041-51.315,51.315v189.754h-5.012c-11.418,0-20.678,9.251-20.678,20.679v125.404
                            c0,11.427,9.259,20.677,20.678,20.677h5.012v22.995c0,28.305,23.025,51.315,51.315,51.315h264.223
                            c28.272,0,51.3-23.011,51.3-51.315V121.449L315.458,0z M99.053,284.379c6.06-1.024,14.578-1.796,26.579-1.796
                            c12.128,0,20.772,2.315,26.58,6.965c5.548,4.382,9.292,11.615,9.292,20.127c0,8.51-2.837,15.745-7.999,20.646
                            c-6.714,6.32-16.643,9.157-28.258,9.157c-2.585,0-4.902-0.128-6.714-0.379v31.096H99.053V284.379z M386.034,450.713H121.811
                            c-10.954,0-19.874-8.92-19.874-19.889v-22.995h246.31c11.42,0,20.679-9.25,20.679-20.677V261.748
                            c0-11.428-9.259-20.679-20.679-20.679h-246.31V51.315c0-10.938,8.921-19.858,19.874-19.858l181.89-0.19v67.233
                            c0,19.638,15.934,35.587,35.587,35.587l65.862-0.189l0.741,296.925C405.891,441.793,396.987,450.713,386.034,450.713z
                             M174.065,369.801v-85.422c7.225-1.15,16.642-1.796,26.58-1.796c16.516,0,27.226,2.963,35.618,9.282
                            c9.031,6.714,14.704,17.416,14.704,32.781c0,16.643-6.06,28.133-14.453,35.224c-9.157,7.612-23.096,11.222-40.125,11.222
                            C186.191,371.092,178.966,370.446,174.065,369.801z M314.892,319.226v15.996h-31.23v34.973h-19.74v-86.966h53.16v16.122h-33.42
                            v19.875H314.892z"/>
                    </g>

                    </svg>
            </div>
        </div>;
    }

    function addZ(n: number){return n<10? '0'+n:''+n;}

    function chooseView() {
        return <div className="choose-view">
            <div className="submit-prompt">
                <h1>Submit Your Request</h1>
                <p>
                    Once you and your doctor have completed, and each have signed the form, you are ready to submit the form here. Attach an image (photos) of each page or scanned copy (PDF) of the signed form. Then click ‘submit’.
                </p>
                <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>updateDoctype(DocumentType[DocumentType.JPG])}>
                    <div className="mdc-button__ripple"></div>
                    <span className="mdc-button__label">Image (Photos)</span>
                </button>
                <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>updateDoctype(DocumentType[DocumentType.PDF])}>
                    <div className="mdc-button__ripple"></div>
                    <span className="mdc-button__label">PDF</span>
                </button>
            </div>
            <div className="claimant-details">
                <h3>Claimant Details</h3>
                <p>Name:</p>
                <p>{firstName} {lastName}</p>
                <p>Date of birth:</p>
                <p>{`${addZ(Number(dateOfBirthDay))}/${addZ(Number(dateOfBirthMonth)+1)}/${dateOfBirthYear}`}</p>
                <p>Gender:</p>
                <p>{gender.charAt(0) + gender.slice(1).toLowerCase()}</p>
            </div>

            <div className="nav-buttons">
                <div>
                    <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>{
                        updateStepOneVisible(true);
                        updateStepTwoVisible(false);
                    }}>
                        <div className="mdc-button__ripple"></div>
                        <span className="mdc-button__label">Go back</span>
                    </button>
                </div>
                <div></div>
            </div>
        </div>;
    }

    return (
        <div className="new-admin-exception-container" ref={root}>
            <ThemeProvider theme={theme}>
                <div className={'step-one '+(stepOneVisible ? '' : 'hidden')}>
                    <h1>Submit Your Request</h1>
                    <div className="plan-member-details">
                        <div>
                            <p className="header">Information about the plan member</p>
                            <p>Here you provide information about the plan member, including the plan member’s policy number, name, certificate number, organization, and agree to our Terms of Service and Privacy Policy</p>
                        </div>
                        <div></div>
                        <TextField
                            id="member-first-name-input"
                            label="First name"
                            value={memberFirstName}
                            onChange={handleMemberFirstNameChange}
                            variant="filled"
                            margin="normal"
                        />
                        <TextField
                            id="member-last-name-input"
                            label="Last name"
                            value={memberLastName}
                            onChange={handleMemberLastNameChange}
                            variant="filled" 
                            margin="normal"
                        />
                        <TextField
                            id="policy-number-input"
                            label="Policy/Plan number"
                            defaultValue={policyNumber}
                            onChange={handlePolicyNumberChange}
                            variant="filled" 
                            margin="normal"
                            type="number"
                        />
                        <TextField
                            id="certificate-number-input"
                            label="Certificate/Member ID number"
                            value={certificateNumber}
                            onChange={handleCertificateNumberChange}
                            onKeyDown={handleCertificateNumberKeyDown}
                            variant="filled" 
                            margin="normal"
                            type="text"
                        />
                        <TextField
                            id="oranization-name-input"
                            label="Organization/Dealership name"
                            value={organizationName}
                            onChange={handleOrganizationNameChange}
                            variant="filled" 
                            margin="normal"
                        />
                        <div></div>
                        <div>
                            <p>Relationship to Plan Member</p>
                            <RadioGroup aria-required aria-label="relationship" name="relationship" value={relationshipType} onChange={handleRelationshipTypeChange} row>
                                <FormControlLabel value={RelationshipType[RelationshipType.MEMBER]} control={<Radio color="primary" />} label="Plan Member" />
                                <FormControlLabel value={RelationshipType[RelationshipType.SPOUSE]} control={<Radio color="primary" />} label="Spouse" />
                                <FormControlLabel value={RelationshipType[RelationshipType.DEPENDANT]} control={<Radio color="primary" />} label="Dependent child" />
                            </RadioGroup>
                        </div>
                    </div>
                    <div className="claimant-details">
                        <div>
                            <div>
                                <p className="header">
                                    {(() => {
                                        switch (relationshipType) {
                                            case RelationshipType[RelationshipType.MEMBER]:
                                                return 'Plan member details';
                                                break;
                                            case RelationshipType[RelationshipType.SPOUSE]:
                                                return 'Spouse details';
                                                break;
                                            case RelationshipType[RelationshipType.DEPENDANT]:
                                                return 'Dependent details';
                                                break;
                                            default:
                                                return 'Claimant details';
                                                break;
                                        }
                                    })()}
                                </p>
                            </div>
                            <div className="name">
                                <TextField
                                    id="firstname-input"
                                    label="First name"
                                    value={firstName}
                                    onChange={handleFirstNameChange}
                                    variant="filled" 
                                    margin="normal"
                                />
                                <TextField
                                    id="lastname-input"
                                    label="Last name"
                                    value={lastName}
                                    onChange={handleLastNameChange}
                                    variant="filled"
                                    margin="normal"
                                />

                            </div>
                            <p>Date of Birth</p>
                            <div className="date-of-birth">
                                <TextField
                                    id="year-input"
                                    label="Year"
                                    value={dateOfBirthYear}
                                    onChange={handleYearChange}
                                    error={dateOfBirthYear !== '' && (Number(dateOfBirthYear) < 1900 || Number(dateOfBirthYear) > 3000)}
                                    variant="filled"
                                    margin="normal"
                                    type="number"
                                />
                                <FormControl variant="filled" margin="normal">
                                    <InputLabel id="month-input-label">Month</InputLabel>
                                    <Select
                                        labelId="month-input-label"
                                        id="month-input"
                                        value={dateOfBirthMonth}
                                        onChange={handleMonthChange}
                                    >
                                        <MenuItem value={0}>January</MenuItem>
                                        <MenuItem value={1}>February</MenuItem>
                                        <MenuItem value={2}>March</MenuItem>
                                        <MenuItem value={3}>April</MenuItem>
                                        <MenuItem value={4}>May</MenuItem>
                                        <MenuItem value={5}>June</MenuItem>
                                        <MenuItem value={6}>July</MenuItem>
                                        <MenuItem value={7}>August</MenuItem>
                                        <MenuItem value={8}>September</MenuItem>
                                        <MenuItem value={9}>October</MenuItem>
                                        <MenuItem value={10}>November</MenuItem>
                                        <MenuItem value={11}>December</MenuItem>
                                    </Select>
                                </FormControl>
                                <TextField
                                    id="day-input"
                                    label="Day"
                                    value={dateOfBirthDay}
                                    onChange={handleDayChange}
                                    error={dateOfBirthDay !== '' && (Number(dateOfBirthDay) < 1 || Number(dateOfBirthDay) > 31)}
                                    variant="filled"
                                    margin="normal"
                                    type="number"
                                />
                            </div>
                            <div>
                                <p>Gender</p>
                                <RadioGroup aria-required aria-label="gender" name="gender" value={gender} onChange={handleGenderChange} row>
                                    <FormControlLabel value={Gender[Gender.MALE]} control={<Radio color="primary" />} label="Male" />
                                    <FormControlLabel value={Gender[Gender.FEMALE]} control={<Radio color="primary" />} label="Female" />
                                    <FormControlLabel value={Gender[Gender.OTHER]} control={<Radio color="primary" />} label="Other" />
                                </RadioGroup>
                            </div>
                        </div>
                        <div className="consent">
                            <FormControlLabel
                                control={<Checkbox checked={consented} onChange={handleConsentChange} />}
                                label="By clicking here, I confirm that I am authorized to submit this form on behalf of the claimant"
                            />
                        </div>
                    </div>
                    <div>
                    </div>
                    <div>
                        {
                            !stepTwoAvailable()
                            ? <button className="inactive mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped ">
                                    <div className="mdc-button__ripple"></div>
                                    <span className="mdc-button__label">Next</span>
                            </button>
                            : <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>{ 
                                updateStepOneVisible(false);
                                updateStepTwoVisible(true);
                            }}>
                                <div className="mdc-button__ripple"></div>
                                <span className="mdc-button__label">Next</span>
                            </button>

                        }
                    </div>
                </div>

                <div className={'step-two '+(stepTwoVisible ? '' : 'hidden')}>

                    {
                        docType === undefined
                        ? chooseView()
                        : docType === DocumentType[DocumentType.JPG]
                            ? imagesView()
                            : PDFView()
                    }

                    {
                        docType === undefined
                            ? ''
                            : <div className="nav-buttons">
                                <div>
                                    <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>{
                                        updateDoctype(undefined);
                                    }}>
                                        <div className="mdc-button__ripple"></div>
                                        <span className="mdc-button__label">Go back</span>
                                    </button>
                                </div>
                                <div>
                                    {images !== undefined || pdf !== undefined
                                    ? <button disabled={submitting} className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" onClick={createDrugException}>
                                        <div className="mdc-button__ripple"></div>
                                        <span className="mdc-button__label">Submit Request</span>
                                    </button>
                                    : <button disabled className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" >
                                        <div className="mdc-button__ripple"></div>
                                        <span className="mdc-button__label">Submit Request</span>
                                    </button>}
                                </div>
                            </div>
                    }
                </div>
            </ThemeProvider>
        </div>
    );

}
